import { createAction, createSlice } from "@reduxjs/toolkit";
import {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/CashManagementProvider";
import listFactory from "./listFactory";

const { slicePart, selectors } = listFactory<CashManagementProvider>(
  "cashManagementProvider"
);

const initialState = {
  ...slicePart.initialState,
  currencies: [] as CashManagementProviderCurrencies[],
  configurableProviders: [] as CashManagementProvider[],
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
    setSupportedCurrencies: (state, action) => {
      const { data } = action.payload;
      state.currencies = data;
    },
    setCashManagementConfigurableProviders: (state, action) => {
      const { data } = action.payload;
      state.configurableProviders = data.list;
    },
  },
});

export const {
  setList,
  setItem,
  setSupportedCurrencies,
  setCashManagementConfigurableProviders,
} = slice.actions;

export const fetchCashManagementProviders = createAction(
  "fetchCashManagementProviders"
);
export const fetchCashManagementSupportedCurrencies = createAction(
  "fetchCashManagementSupportedCurrencies"
);
export const fetchCashManagementConfigurableProviders = createAction(
  "fetchCashManagementConfigurableProviders"
);

export const selectSupportedCurrencies = (state: any) => {
  return state.cashManagementProvider.currencies;
};

export const selectCashManagementConfigurableProviders = (state: any) => {
  return state.cashManagementProvider.configurableProviders;
};

export const { selectList: selectCashManagementProviders } = selectors;

export const cashManagementProviderOperationPaths = () => {
  return {
    configurableProviders: [
      "cashManagement",
      "providers",
      "configurableProviders",
    ],
  };
};

export default slice.reducer;
